<h3 class="page-subheader" *ngIf="title">{{ title }}</h3>

<ng-container *ngIf="!outOfEurotax">
    <div class="row form-row">
        <div class="col-4">
            <app-select [ngModel]="data.eurotax.categoryId"
                        (ngModelChange)="categoryId = $event"
                        [disabled]="categories.length === 0"
                        [itemList]="categories"
                        bindValue="categoryId"
                        bindDescription="categoryDescription"
                        [label]="'MOTOR_CONFIG.MOTOR_TYPE' | translate"
                        [placeholder]="'LABEL.PICK' | translate"
                        [errorStateMatcher]="matchers.eurotax.categoryId">
            </app-select>
        </div>
        <div class="col-4">
            <app-numeric [(ngModel)]="data.productionYear"
                         (onBlur)="downloadMakesDebounced()"
                         [disabled]="outOfEurotax"
                         [config]="{thousands: '', maxLength: 4}"
                         [label]="'MOTOR_CONFIG.MANUFACTURE_YEAR' | translate"
                         [errorStateMatcher]="matchers.productionYear">
            </app-numeric>
        </div>
        <div class="col-4">
            <app-select [ngModel]="data.eurotax.makeId"
                        (ngModelChange)="makeId = $event"
                        [disabled]="makes.length === 0"
                        [itemList]="makes"
                        bindValue="makeId"
                        bindDescription="makeDescription"
                        [label]="'MOTOR_CONFIG.MAKE' | translate"
                        [placeholder]="'LABEL.PICK' | translate"
                        [errorStateMatcher]="matchers.eurotax.makeId">
            </app-select>
        </div>
    </div>

    <div class="row form-row">
        <div class="col-4">
            <app-select [ngModel]="data.eurotax.modelId"
                        (ngModelChange)="modelId = $event"
                        [disabled]="models.length === 0"
                        [itemList]="models"
                        bindValue="modelId"
                        bindDescription="modelDescription"
                        [label]="'MOTOR_CONFIG.MODEL' | translate"
                        [placeholder]="'LABEL.PICK' | translate"
                        [errorStateMatcher]="matchers.eurotax.modelId">
            </app-select>
        </div>
        <div class="col-4">
            <app-select [ngModel]="data.eurotax.bodyType"
                        (ngModelChange)="bodyType = $event"
                        [disabled]="bodyTypes.length === 0"
                        [itemList]="bodyTypes"
                        [label]="'MOTOR_CONFIG.BODY_TYPE' | translate"
                        [placeholder]="'LABEL.PICK' | translate"
                        [errorStateMatcher]="matchers.eurotax.bodyType">
            </app-select>
        </div>
        <div class="col-4">
            <app-select [ngModel]="data.eurotax.doorCount"
                        (ngModelChange)="doorCount = $event"
                        [disabled]="doors.length === 0"
                        [itemList]="doors"
                        bindValue="doorCount"
                        bindDescription="doorCount"
                        [label]="'MOTOR_CONFIG.DOOR_NUMBER' | translate"
                        [placeholder]="'LABEL.PICK' | translate"
                        [errorStateMatcher]="matchers.eurotax.doorCount">
            </app-select>
        </div>
    </div>

    <div class="row form-row">
        <div class="col-4">
            <app-select [ngModel]="data.eurotax.fuelType"
                        (ngModelChange)="fuelType = $event"
                        [disabled]="fuelTypes.length === 0"
                        [itemList]="fuelTypes"
                        [label]="'MOTOR_CONFIG.FUEL_TYPE' | translate"
                        [placeholder]="'LABEL.PICK' | translate"
                        [errorStateMatcher]="matchers.eurotax.fuelType">
            </app-select>
        </div>
        <div class="col-4">
            <app-select [ngModel]="data.eurotax.capacity"
                        (ngModelChange)="capacity = $event"
                        [disabled]="capacities.length === 0"
                        [itemList]="capacities"
                        [label]="'MOTOR_CONFIG.ENGINE_SIZE' | translate"
                        [placeholder]="'LABEL.PICK' | translate"
                        [errorStateMatcher]="matchers.eurotax.capacity">
            </app-select>
        </div>
        <div class="col-4">
            <app-select [ngModel]="data.eurotax.gearBoxType"
                        (ngModelChange)="gearBoxType = $event"
                        [disabled]="gearBoxTypes.length === 0"
                        [itemList]="gearBoxTypes"
                        [label]="'MOTOR_CONFIG.TRANSMISSION' | translate"
                        [placeholder]="'LABEL.PICK' | translate"
                        [errorStateMatcher]="matchers.eurotax.gearBoxType">
            </app-select>
        </div>
    </div>

    <ng-container *ngIf="versions.length > 0">
        <div class="separator"></div>
        <mat-radio-group [(ngModel)]="data.eurotax.typeId">
            <table class="table table-simple">
                <colgroup>
                    <col width="30px">
                    <col>
                    <col>
                    <col>
                    <col>
                    <col>
                    <col>
                    <col>
                </colgroup>

                <thead>
                <tr>
                    <td></td>
                    <td>{{ 'MOTOR_CONFIG.MODEL' | translate }}</td>
                    <td>{{ 'MOTOR_CONFIG.VERSION' | translate }}</td>
                    <td class="text-right">{{ 'MOTOR_CONFIG.EUROTAX_ID' | translate }}</td>
                    <td class="text-right">{{ 'MOTOR_CONFIG.KW' | translate }}</td>
                    <td>{{ 'MOTOR_CONFIG.TRANSMISSION' | translate }}</td>
                    <td class="text-right">{{ 'MOTOR_CONFIG.TRANSMISSIONS_NUMBER' | translate }}</td>
                    <td class="text-right">{{ 'MOTOR_CONFIG.NUMBER_OF_SEATS' | translate }}</td>
                </tr>

                </thead>

                <tbody>
                <tr *ngFor="let version of versions">
                    <td>
                        <mat-radio-button [value]="version.typeId">
                        </mat-radio-button>
                    </td>
                    <td>{{ version.modelDescription }}</td>
                    <td>{{ version.typeDescription }}</td>
                    <td class="text-right">{{ version.typeId }}</td>
                    <td class="text-right">{{ version.watPower | suffixLabel : 'LABEL.SUFFIX_KW' }}</td>
                    <td>{{ version.gearBoxTypeItem.description }}</td>
                    <td class="text-right">{{ version.gearCount }}</td>
                    <td class="text-right">{{ version.seatCount }}</td>
                </tr>
                </tbody>
            </table>
        </mat-radio-group>
    </ng-container>

    <app-errors [errorStateMatcher]="matchers.eurotax.typeId"></app-errors>
</ng-container>

<div class="separator"></div>

<div class="row form-row">
    <div class="col-6">
        <mat-checkbox [(ngModel)]="outOfEurotax">
            {{ 'MOTOR_CONFIG.NOT_IN_EUROTAX' | translate }}
        </mat-checkbox>
    </div>
</div>

<div class="separator"></div>
